
import React, {Component} from 'react';
import './SurveyForm.scss';
import {
  Button,
} from 'reactstrap';

class SaveButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      waitText: "",
      btnColor: "",
      disabled: false
    }

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    e.preventDefault();
    this.setState({
      disabled: true
    }, () => {
      this.props.onClick()
      .then((result) => {
        if ( !result.error ) {
          this.setState({
            saved: true,
            waitText: "Success",
            btnColor: "btn-success"
          });
        } else {
          this.setState({
            saved: true,
            waitText: "Error",
            btnColor: "btn-danger"
          });
        }
      });
    })
  }

  resetState() {
    this.setState({
      saved: false,
      waitText: "",
      btnColor: "",
      disabled: false
    });
  }

  componentDidUpdate() {
    if ( this.state.saved ) {
      setTimeout(() => {
        this.resetState()
      }, 3000);
    }
  }

  render() {
    return (
      <Button disabled={this.state.disabled} className={`btn ${this.state.btnColor} ${this.props.className}`} onClick={this.handleOnClick}>{ this.state.waitText || this.props.text }</Button>
    )
  }
}

SaveButton.defaultProps = {
  text: "Save"
};

export default SaveButton;


// WEBPACK FOOTER //
// ./src/components/SurveyView/SurveyForm/SaveButton.js